import React from 'react'
import PropTypes from 'prop-types'
import { ToggleSelectionOnClick } from '@morningtrain/react-resources'
import TableHead from './TableHead'
import TableBody from './TableBody'
import TableRow from './TableRow'
import TableFooter from './TableFooter'

function Table (props) {
  const rowComponent = (props.selectOnClick === true) ? (
    <ToggleSelectionOnClick multiple={props.selectMultiple}>
      <TableRow row={props.row}>
        {props.children}
      </TableRow>
    </ToggleSelectionOnClick>
  ) : (
    <TableRow row={props.row}>
      {props.children}
    </TableRow>
  )

  return (
    <table className={props.className}>
      {(props.headless === true)
        ? null
        : (
          <>
            <TableHead extraHeader={props.extraHeader}>
              {props.children}
            </TableHead>
          </>
          )}
      <TableBody>
        {rowComponent}
      </TableBody>
      {props.footer === null
        ? (props.withFooter === true
            ? (
              <TableFooter>
                {props.children}
              </TableFooter>
              )
            : null)
        : (
          <tfoot>
            {props.footer}
          </tfoot>
          )}
    </table>
  )
}

Table.defaultProps = {
  extraHeader: null,
  className: null,
  headless: false,
  selectOnClick: false,
  selectMultiple: false,
  footer: null,
  row: null,
  withFooter: false
}

Table.propTypes = {
  extraHeader: PropTypes.node,
  className: PropTypes.string,
  headless: PropTypes.bool,
  selectOnClick: PropTypes.bool,
  selectMultiple: PropTypes.bool,
  footer: PropTypes.node,
  row: PropTypes.any,
  withFooter: PropTypes.bool
}

export default Table
